"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMessage = void 0;

const generateMessage = (type, messages, min, max) => {
  var _messages$type;

  return messages ? (_messages$type = messages[type]) == null ? void 0 : _messages$type.replace('%min%', min).replace('%max%', max) : '';
};

exports.generateMessage = generateMessage;